import GiftAid from './GiftAid';

export default GiftAid;
